import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';

/**
 * ThemeManager handles switching between dark and light themes
 * based on the current route.
 */
export const ThemeManager: React.FC = () => {
  const location = useLocation();
  const { resolvedTheme } = useTheme();

  useEffect(() => {
    // List of routes that should ALWAYS be in light mode
    const lightRoutes = [
      '/',              // Landing Page
      '/login',         // Login
      '/register',      // Registration page
      '/pricing',       // Pricing page
      '/admin',         // Admin panel (strictly forced light)
      '/trial-expired', // Expired trial page
      '/blog',          // Public blog list
      '/blog/',         // Blog posts
      '/pages/',        // CMS pages
    ];

    const isLightRoute = lightRoutes.some(route =>
      location.pathname === route || (route !== '/' && location.pathname.startsWith(route))
    );

    // If it's a light-only route, force light mode class
    // Otherwise, use the resolved theme from context (user preference or system)
    const effectiveTheme = isLightRoute ? 'light' : resolvedTheme;

    if (effectiveTheme === 'dark') {
      document.documentElement.classList.add('dark');
      document.documentElement.style.colorScheme = 'dark';
    } else {
      document.documentElement.classList.remove('dark');
      document.documentElement.style.colorScheme = 'light';
    }
  }, [location.pathname, resolvedTheme]);

  return null; // This component doesn't render anything
};
